(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("base"), require("core"), require("ui"), require("module-common-abc"), require("module-mobile-utils"));
	else if(typeof define === 'function' && define.amd)
		define(["base", "core", "ui", "module-common-abc", "module-mobile-utils"], factory);
	else if(typeof exports === 'object')
		exports["widget-login-abc"] = factory(require("base"), require("core"), require("ui"), require("module-common-abc"), require("module-mobile-utils"));
	else
		root["widget-login-abc"] = factory(root["base"], root["core"], root["ui"], root["module-common-abc"], root["module-mobile-utils"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_3__, __WEBPACK_EXTERNAL_MODULE_4__, __WEBPACK_EXTERNAL_MODULE_5__, __WEBPACK_EXTERNAL_MODULE_6__, __WEBPACK_EXTERNAL_MODULE_7__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1);


/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module) {'use strict'; /**
	               *  ----------------------------------------------------------------
	               *  Copyright © Backbase B.V.
	               *  ----------------------------------------------------------------
	               *  Author : Backbase R&D - Amsterdam - New York
	               *  Filename : main.js
	               *  Description: Provides the ability to login using simple authentication
	               *  ----------------------------------------------------------------
	               */

	!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {

	    'use strict';

	    module.name = 'widget-login-abc';

	    var base = __webpack_require__(3);
	    var core = __webpack_require__(4);
	    var ui = __webpack_require__(5);
	    var common = __webpack_require__(6);
	    var mobileUtils = __webpack_require__(7);

	    var Model = __webpack_require__(8);

	    var deps = [
	    core.name,
	    ui.name,
	    common.name,
	    mobileUtils.name];


	    // @ngInject
	    function run() {
	        // Module is Bootstrapped
	    }

	    module.exports = base.createModule(module.name, deps).
	    service(__webpack_require__(9)).
	    controller(__webpack_require__(10)).
	    factory('model', Model).
	    directive(__webpack_require__(11)).
	    run(run);
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)(module)))

/***/ },
/* 2 */
/***/ function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ },
/* 3 */
/***/ function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_3__;

/***/ },
/* 4 */
/***/ function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_4__;

/***/ },
/* 5 */
/***/ function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_5__;

/***/ },
/* 6 */
/***/ function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_6__;

/***/ },
/* 7 */
/***/ function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_7__;

/***/ },
/* 8 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict'; /**
	               * Models
	               * @module models
	               */
	!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports) {

	    'use strict';

	    /**
	                   * @constructor
	                   * @ngInject
	                   */
	    function WidgetModel(lpWidget, lpCoreUtils, $resource) {
	        var state = {
	            statusDetailUrl: lpCoreUtils.resolvePortalPlaceholders(lpWidget.getPreference('statusDetailUrl')) || '/portalserver/services/rest/v1/user-status-detail',
	            sessionAliveUrl: lpCoreUtils.resolvePortalPlaceholders(lpWidget.getPreference('sessionAliveUrl')) || '/portalserver/services/rest/v1/public/handshake',
	            userPortfolioInfoUrl: lpCoreUtils.resolvePortalPlaceholders(lpWidget.getPreference('userPortfolioInfoUrl')) || '/portalserver/services/rest/v1/portfolio' };


	        var model = {};
	        /**
	                         * @public
	                         * @return {Object} current model state
	                         */
	        model.getState = function () {
	            return state;
	        };

	        model.statusDetail = $resource(state.statusDetailUrl);
	        model.sessionAlive = $resource(state.sessionAliveUrl);
	        model.userPortfolioInfo = $resource(state.userPortfolioInfoUrl);

	        return model;
	    }

	    module.exports = WidgetModel;
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 9 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict';!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {
	    'use strict';

	    // @ngInject
	    exports.LoginService = function ($http, $window, lpPortal, lpWidget, lpCoreUtils, $q) {

	        ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	        // Login model
	        ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

	        var self = this;
	        var config = {
	            loginUrl: lpPortal.root + '/bb-public-api/security/login',
	            otpValidationUrl: lpPortal.root + '/services/rest/v1/2fa-login',
	            setPasswordUrl: lpPortal.root + '/services/rest/v1/password',
	            getQrUrl: lpPortal.root + '/services/rest/v1/otp/activation',
	            otpBindUrl: lpPortal.root + '/services/rest/v1/binding',
	            logoutUrl: lpPortal.root + '/bb-public-api/security/logout',
	            sessionAlive: lpPortal.root + '/services/rest/v1/public/handshake',
	            optActivationUrl: lpPortal.root + '/services/rest/v1/otp/activation',
	            userStatusUrl: lpPortal.root + '/services/rest/v1/user-status' };


	        /**
	                                                                               * Login
	                                                                               */
	        this.doLogin = function (userId, password, otp, token) {
	            var promise = this.getLoginPromise(userId, password).success(function (response) {
	                self.error = null;

	            }).error(function (response) {
	                self.error = response.errors[0].code;

	            });
	            return promise;
	        };

	        this.getLoginPromise = function (userId, password) {
	            /*eslint-disable camelcase*/
	            var data = {
	                j_username: userId,
	                j_password: password };


	            /*eslint-enable */

	            return $http.post(config.loginUrl, lpCoreUtils.buildQueryString(data), {
	                headers: {
	                    'Accept': 'application/json',
	                    'Content-Type': 'application/x-www-form-urlencoded;',
	                    'Cache-Control': 'no-cache, no-store, must-revalidate',
	                    'Pragma': 'no-cache',
	                    'Expires': '0',
	                    'X-BBXSRF': '' } });


	        };

	        this.sessionAlive = function () {
	            return $http.get(config.sessionAlive).then(function (success) {
	                localStorage.setItem("token", success.headers('X-BBXSRF'));
	            }, function (error) {
	                localStorage.setItem("token", error.headers('X-BBXSRF'));
	            });
	        };

	        /**
	            * Authentication and OTP access
	            */
	        this.verifyPreAuthentication = function (userId, password, token) {

	            return $q(function (resolve, reject) {
	                var data = {
	                    j_username: userId,
	                    j_password: password };

	                $http.post(config.loginUrl, lpCoreUtils.buildQueryString(data), {
	                    headers: {
	                        'Accept': 'application/json',
	                        'Content-Type': 'application/x-www-form-urlencoded;',
	                        'Cache-Control': 'no-cache, no-store, must-revalidate',
	                        'Pragma': 'no-cache',
	                        'Expires': '0' } }).

	                then(function (response) {
	                    self.error = null;
	                    resolve(response);
	                }, function (response) {
	                    self.error = response.data.errors[0].code;
	                    reject(response);
	                });

	            });

	        };

	        this.verifyOtp = function (userOtp, isFirstTime) {
	            var payload, url;

	            if (isFirstTime) {
	                url = config.otpBindUrl;
	                payload = {
	                    vascoChallenge: userOtp };

	            } else {
	                url = config.otpValidationUrl;
	                payload = {
	                    otp: userOtp };

	            }
	            return $q(function (resolve, reject) {
	                $http.post(url, payload).then(function (success) {
	                    resolve(success);
	                }, function (error) {
	                    reject(error);
	                });

	            });
	        };

	        this.verifyOTPBindedWithAccount = function () {
	            return $q(function (resolve, reject) {
	                $http.post(config.optActivationUrl).then(function (response) {
	                    self.error = null;
	                    if (response.data)
	                    resolve(response);
	                }, function (response) {
	                    self.error = response.data.errors[0].code;
	                    reject(response);
	                });

	            });
	        };

	        this.setPassword = function (newPassword) {
	            var payload = {
	                newPassword: newPassword };


	            return $q(function (resolve, reject) {
	                $http.post(config.setPasswordUrl, payload).then(function (success) {
	                    resolve(success);
	                }, function (error) {
	                    reject(error);
	                });

	            });
	        };

	        this.getQrCode = function (token) {
	            return $q(function (resolve, reject) {
	                $http.get(config.getQrUrl, {
	                    headers: {
	                        'Accept': 'application/json',
	                        'Content-Type': 'application/x-www-form-urlencoded;',
	                        'Cache-Control': 'no-cache, no-store, must-revalidate',
	                        'Pragma': 'no-cache',
	                        'Expires': '0',
	                        'X-BBXSRF': token } }).
	                then(function (success) {
	                    resolve(success);
	                }, function (error) {
	                    reject(error);
	                });
	            });
	        };

	        this.bindOtp = function () {
	            return $q(function (resolve, reject) {
	                $http.post(config.otpBindUrl).then(function (success) {
	                    resolve(success);
	                }, function (error) {
	                    reject(error);
	                });
	            });
	        };

	        this.getUserStatus = function () {
	            return $q(function (resolve, reject) {
	                $http.get(config.userStatusUrl).then(function (success) {
	                    resolve(success);
	                }, function (error) {
	                    reject(error);
	                });
	            });
	        };

	        this.logout = function (token, redirect) {

	            var data = {
	                BBXSRF: token,
	                portal_name: lpPortal.name,
	                page_name: lpPortal.page.name };


	            if (redirect === true) {
	                data.redirect = '/portalserver/' + lpPortal.name + '/sign-in';
	            }

	            $window.sessionStorage.clear();

	            $http.post(config.logoutUrl, lpCoreUtils.buildQueryString(data), {
	                headers: {
	                    'Accept': 'application/json',
	                    'Content-Type': 'application/x-www-form-urlencoded;',
	                    'Cache-Control': 'no-cache, no-store, must-revalidate',
	                    'Pragma': 'no-cache',
	                    'Expires': '0' } }).

	            then(function (response) {
	                if (redirect)
	                $window.location.href = lpPortal.root + '/' + lpPortal.name + '/sign-in';
	            }, function (response) {
	            });

	        };

	    };
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 10 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;"use strict";!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports) {
	  "use strict";

	  // @ngInject
	  exports.LoginController = function (
	  model,
	  $scope,
	  lpWidget,
	  lpPortal,
	  $window,
	  LoginService,
	  $location,
	  $q,
	  $http,
	  $timeout,
	  $interval,
	  $document,
	  lpCoreUtils,
	  lpCoreBus,
	  lpConstants,
	  TranslateService,
	  tmxProfilerService)
	  {
	    var self = this;

	    $scope.BBXSRF = getCookie(lpConstants.COMMON.COOKIE_BBXSRF);
	    $scope.template = "first";
	    $scope.error = "";
	    $scope.delay = 0;
	    self.lastSubmit = 0;
	    $scope.timer = 0;
	    $scope.modalWindowOpen = false;
	    $scope.confirmationWindowOpen = false;
	    $scope.isSuccess = false;
	    $scope.isFailure = false;
	    $scope.tokenSuccess = true;
	    $scope.loginError = false;
	    $scope.loginErrorMsg = "";
	    $scope.isServerError = false;
	    $scope.isSessionError = false;
	    $scope.loginServerErrorMsg = TranslateService.translate(
	    "abc.common.error.oops");

	    $scope.isUnauthorizedError = false;
	    $scope.doubleClick = true;
	    $scope.isLoginWindow = true;
	    $scope.handshakeTimer = lpWidget.getPreference("handshakeTimer") || 1800000;
	    $scope.csrfTokenExpried = false;
	    $scope.isFirstTime = null;
	    $scope.toggleOnBoardingFlow = lpCoreUtils.parseBoolean(
	    lpWidget.getPreference("toggleOnBoardingFlow"));

	    $scope.password = {
	      newPassword: "",
	      confirmPassword: "",
	      pattern: /^(?=.*\d.*\d.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[^a-zA-Z0-9\x20])(?=\S+$).{8,}$/ };


	    $scope.bindingDetails = {
	      qrCode: "",
	      serialNumber: "",
	      activationCode: "" };

	    setInterval(function () {
	      $scope.csrfTokenExpried = true;
	    }, $scope.handshakeTimer);

	    $scope.userOTP = {
	      otp: null };


	    window.sessionStorage.removeItem("userSessionId");
	    window.localStorage.removeItem("countryPreferences");

	    self.verifyUserResponse = {};

	    startIdleTime();

	    function startIdleTime() {
	      $interval(function () {
	        model.sessionAlive.get().$promise.then(function (success) {
	          //session keep alive
	        });
	      }, 120000);
	    }

	    function sendTmxProfiler() {
	      tmxProfilerService.sendLoginTmxProfiler($scope.user.id, $scope.user.password);
	    }

	    $scope.regexNumChar = /^[a-zA-Z0-9]+$/;

	    $scope.user = {};
	    $scope.user.otp = "";
	    $scope.clean = function () {
	      $scope.user.id = "";
	      $scope.user.password = "";
	      clearOtp();
	    };

	    $scope.allowDoNext = function () {
	      return $scope.user.id && $scope.user.password;
	    };

	    $scope.moveFocus = function (nextId) {
	      angular.element($document[0].querySelector("#" + nextId)).focus();
	    };

	    $scope.allowSubmit = function () {
	      if ($scope.timer > 0)
	      {
	        return false;
	      } else
	      if (
	      $("#txtLogin").val() !== "" &&
	      $("#txtLogin").val().toString().length === 6 &&
	      $scope.delay === 0 &&
	      $scope.doubleClick)
	      {
	        angular.element("#submitLoginOtp").focus();
	        return true;
	      } else {
	        return false;
	      }
	    };

	    function clearOtp() {
	      $scope.userOTP.otp = null;
	    }

	    $scope.handleVerifyUserResponse = function () {
	      if (self.verifyUserResponse) {
	        $scope.modalWindowOpen = false;

	        var userSessionId = self.verifyUserResponse.headers("userSessionId");
	        $window.sessionStorage.setItem("userSessionId", userSessionId);
	        var responseStatus =
	        self.verifyUserResponse.data && self.verifyUserResponse.data.status ?
	        self.verifyUserResponse.data.status :
	        "";

	        if (responseStatus === "LOGIN_FIRST_TIME") {
	          $scope.template = "setPassword";
	          $scope.isFirstTime = true;
	          $scope.isLoginWindow = false;
	        } else if (responseStatus === "DEVICE_NOT_BOUND") {
	          $scope.isFirstTime = true;
	          $scope.isLoginWindow = false;

	          if ($scope.toggleOnBoardingFlow) {
	            $scope.template = "toggle_on_boarding";
	          } else {
	            $scope.template = "qr";
	            $scope.getQr();
	          }
	        } else if (
	        responseStatus === "LOGIN_WITH_OTP" ||
	        responseStatus === "LOGIN_WITH_MFA")
	        {
	          $scope.template = "second";
	          $scope.isLoginWindow = false;
	        }
	        tmxProfilerService.sendLoginSuccessTmxProfiler();
	      }
	    };

	    $scope.verifyUser = function () {
	      sendTmxProfiler();
	      if (!self.isLoginLoading) {
	        self.isLoginLoading = true;

	        LoginService.verifyPreAuthentication(
	        $scope.user.id,
	        $scope.user.password,
	        $scope.BBXSRF).
	        then(
	        function (success) {
	          self.isLoginLoading = false;
	          self.verifyUserResponse = success;
	          if (
	          success &&
	          success.headers &&
	          parseInt(success.headers("X_BBSC")) > 1)
	          {
	            $scope.isSessionError = true;
	            $scope.SessionError = TranslateService.translate(
	            "abc.login.previous.session.closed.message");

	            angular.
	            element($("div[data-pid^='bg-container']")).
	            attr("style", "overflow:visible");
	            $scope.modalWindowOpen = true;
	          } else {
	            $scope.handleVerifyUserResponse();
	          }
	        },
	        function (error) {
	          self.isLoginLoading = false;
	          var responseErrorCode =
	          error.data && error.data.errorCode ? error.data.errorCode : "";
	          if (responseErrorCode === lpConstants.COMMON.LOCKED_USER) {
	            $scope.error = TranslateService.translate(
	            "abc.login.account.locked");

	            $scope.clean();
	            return;
	          }
	          $scope.modalWindowOpen = true;
	          $scope.isUnauthorizedError = true;
	          $scope.loginError = true;
	          $scope.accessError = TranslateService.translate(
	          "abc.login.incorrect.username.or.password");

	        });

	      }
	    };

	    $scope.timerCalc = function () {
	      var totalSec = 30 - parseInt((Date.now() - self.lastSubmit) / 1000);

	      if (totalSec > 0) {
	        $scope.timer = totalSec;
	        $scope.$applyAsync();
	        setTimeout($scope.timerCalc, 1000);
	      } else
	      {
	        $scope.timer = 0;
	        $scope.allowSubmit();
	        $scope.$applyAsync();
	      }
	    };

	    $scope.verifyOtp = function () {

	      self.lastSubmit = Date.now();

	      tmxProfilerService.sendLoginOTPTmxProfiler($scope.user.otp);
	      //var delayInMilliseconds = 2000;
	      //setTimeout(function () {

	      LoginService.verifyOtp($scope.user.otp, $scope.isFirstTime).then(
	      function (success) {
	        $scope.error = "";
	        LoginService.getUserStatus().then(
	        function (res) {
	          window.sessionStorage.setItem("islamicUser", res.data.islamic);
	          if (success.data.termsAccepted === undefined) {
	            $scope.getUserTermsAcceptedStatus();
	          } else {
	            checkForFirstTimeUser(success);
	          }
	        },
	        function (error) {});

	      },
	      function (error) {
	        $scope.error = error.data.errorMessages[0].errorMessage;
	      });


	      $scope.timerCalc();
	      //}, delayInMilliseconds);
	    };

	    $scope.getUserTermsAcceptedStatus = function () {
	      LoginService.getUserStatus().then(
	      function (success) {
	        success.data.firstTimeUser = true;
	        checkForFirstTimeUser(success);
	      },
	      function (error) {
	        $scope.isSuccess = false;
	        $scope.isFailure = true;
	        LoginService.logout(token, false);
	      });

	    };

	    $scope.verifyNewPassword = function () {
	      return (
	        $scope.password.newPassword &&
	        $scope.password.confirmPassword &&
	        RegExp($scope.password.pattern).test($scope.password.newPassword) &&
	        $scope.password.confirmPassword === $scope.password.newPassword);

	    };

	    $scope.validatePattern = function () {
	      $scope.isValidPattern = false;
	      var pattern = $scope.password.pattern;
	      var val = confirmPasswordForm.newPassword.value;
	      if (val.length == 0) {
	        $scope.isValidPattern = true;
	        return true;
	      }
	      var returnVal = new RegExp(pattern).test(val);

	      if (returnVal) {
	        $scope.isValidPattern = true;
	        return true;
	      } else {
	        $scope.isValidPattern = false;
	        return false;
	      }
	    };

	    $scope.setPassword = function () {
	      LoginService.setPassword($scope.password.newPassword).then(
	      function (success) {
	        $scope.password.newPassword = "";
	        $scope.password.confirmPassword = "";
	        $scope.error = "";
	        if ($scope.toggleOnBoardingFlow) {
	          $scope.template = "toggle_on_boarding";
	        } else {
	          $scope.template = "qr";
	          $scope.getQr();
	        }
	      },
	      function (error) {
	        $scope.error = "Something is wrong with your password. Try again.";
	        $scope.isFailure = true;
	        $scope.confirmationWindowOpen = true;
	      });

	    };

	    $scope.closeConfirmationWindow = function () {
	      $scope.password.newPassword = "";
	      $scope.password.confirmPassword = "";
	      $scope.confirmationWindowOpen = false;
	      $scope.error = "";

	      if ($scope.isSuccess) {
	        $scope.template = "qr";
	      }
	      $scope.getQr();
	    };

	    $scope.getQr = function () {
	      LoginService.getQrCode($scope.BBXSRF).then(
	      function (success) {
	        $scope.bindingDetails = {
	          qrCode: success.data.qrCode,
	          serialNumber: success.data.serialNumber,
	          activationCode: success.data.activationCode };

	      },
	      function (error) {});

	    };

	    $scope.bindOtp = function () {
	      $scope.isFirstTime = true;
	      $scope.verifyOtp();
	    };

	    $scope.doLogin = function () {
	      // call handshake before login service to make session alive.
	      if ($scope.csrfTokenExpried) {
	        LoginService.sessionAlive().then(function () {
	          doLogin();
	        });
	      } else {
	        doLogin();
	      }
	    };

	    function doLogin() {
	      $scope.doubleClick = false;
	      $scope.BBXSRF = getCookie("BBXSRF");
	      $window.localStorage.removeItem("countryCode");
	      LoginService.doLogin(
	      $scope.user.id,
	      $scope.user.password,
	      $("#txtLogin").val(),
	      $scope.BBXSRF).
	      then(
	      function (data) {
	        $scope.delay = 0;
	        var userSessionId = data.headers("userSessionId");
	        window.sessionStorage.setItem("userSessionId", userSessionId);
	        setTimeout(function () {
	          checkForFirstTimeUser(data);
	        }, $scope.delay);
	      },
	      function (obj) {
	        angular.
	        element($("div[data-pid^='bg-container']")).
	        attr("style", "overflow:visible");
	        $scope.modalWindowOpen = true;
	        if (obj.status === 500) {
	          $scope.isServerError = true;
	          $scope.loginErrorMsg = $scope.loginServerErrorMsg;
	        } else if (obj.status === 401) {
	          $scope.loginError = true;
	          $scope.isUnauthorizedError = true;
	        } else {
	          $scope.loginError = true;
	          $scope.loginErrorMsg =
	          obj.statusText.split(":")[0] ||
	          TranslateService.translate("abc.common.server.error");
	        }
	      });

	    }

	    function checkForFirstTimeUser(response) {
	      $window.localStorage.removeItem("countryCode");
	      window.sessionStorage.setItem(
	      "userStatus",
	      JSON.stringify(response.data));


	      if (!response.data.termsAccepted) {
	        lpCoreBus.publish("launchpad-retail.termsAndConditions", response.data);
	      } else if (
	      response.data.termsAccepted &&
	      response.data.status === "CHANGE_PASSWORD")
	      {
	        lpCoreBus.publish("launchpad-retail.changePassword", {
	          status: lpConstants.COMMON.CHANGE_PASSWORD });

	      } else if (
	      response.data.termsAccepted &&
	      response.data.status === "ACTIVE" &&
	      !response.data.firstTimeUser)
	      {
	        handleSuccessfulLogin(response);
	      } else if (
	      response.data.termsAccepted &&
	      response.data.status === "ACTIVE" &&
	      response.data.firstTimeUser)
	      {
	        $scope.confirmationWindowOpen = true;
	        $scope.isSuccess = true;
	      } else if (response.data.errorCode === "LOCKED") {
	        $scope.error = TranslateService.translate("abc.login.account.locked");
	        $scope.goTo("first");
	        $scope.$apply();
	      }
	    }

	    $scope.verifyOTPAccountLinked = function () {
	      LoginService.verifyPreAuthentication(
	      $scope.user.id,
	      $scope.user.password,
	      $scope.BBXSRF).

	      then(function () {
	        return $q(function (resolve, reject) {
	          LoginService.verifyOTPBindedWithAccount().then(
	          function (obj) {
	            var userSessionId = obj.headers("userSessionId");
	            window.sessionStorage.setItem("userSessionId", userSessionId);

	            $scope.isSuccess = true;
	            showModalWindow(obj.data.maskedEmail);
	            resolve();
	          },
	          function (err) {
	            reject(err);
	          });

	        });
	      }).
	      catch(function (obj) {
	        var errorCode = obj.data.errors[0].code;
	        if (errorCode) {
	          if (errorCode === lpConstants.CUSTOM_ERROR_CODES.ALREADY_EXISTS) {
	            $scope.error = TranslateService.translate(
	            "abc.login.contact.abc.customer.support");

	            LoginService.logout($scope.BBXSRF, false);
	          } else {
	            if (errorCode === lpConstants.CUSTOM_ERROR_CODES.BOUND_ERROR) {
	              $scope.error = TranslateService.translate(
	              "abc.login.contact.abc.customer.support");

	              LoginService.logout(token, false);
	            } else if (
	            errorCode === lpConstants.CUSTOM_ERROR_CODES.UNAUTHORISED)
	            {
	              $scope.error = TranslateService.translate(
	              "abc.login.incorrect.username.password");

	            } else {
	              $scope.error =
	              obj.data.statusText.split(":")[0] ||
	              TranslateService.translate("abc.common.server.error");
	            }
	            $scope.clean();
	            $scope.tokenSuccess = true;
	            $scope.goTo("first");
	          }
	        } else {
	          $scope.error = TranslateService.translate(
	          "abc.common.server.error");

	        }
	      });
	    };

	    function handleSuccessfulLogin(response) {
	      $window.sessionStorage.setItem("token", response.headers("X-BBXSRF"));
	      var userSessionId = response.headers("userSessionId");
	      $window.sessionStorage.setItem("userSessionId", userSessionId);
	      //setting following to true delibrately as this value can be from response :- Dhaval Marthak
	      //$window.sessionStorage.setItem("islamicUser", response.data.countryCode === 'dz');

	      var redirectUrl =
	      $window.location.protocol +
	      "//" +
	      $window.location.host +
	      "/portalserver/" +
	      response.data.countryCode +
	      "/my-banking";
	      $window.location.replace(redirectUrl);
	    }

	    function getCookie(name) {
	      var value = "; " + document.cookie;
	      var parts = value.split("; " + name + "=");
	      if (parts.length == 2) return parts.pop().split(";").shift();else
	      return "";
	    }

	    function showModalWindow(data) {
	      $scope.modalWindowOpen = true;
	      $scope.email = data;
	      angular.
	      element($("div[data-pid^='bg-container']")).
	      attr("style", "overflow:visible");
	    }

	    $scope.closeEmailWindow = function () {
	      if (!$scope.isSessionError) {
	        $scope.modalWindowOpen = false;
	        switchToLogin();
	        angular.element($("div[data-pid^='bg-container']")).removeAttr("style");
	      }
	    };

	    $scope.closeErrorWindow = function () {
	      $scope.modalWindowOpen = false;
	      $scope.loginError = false;
	      switchToLogin();
	      angular.element($("div[data-pid^='bg-container']")).removeAttr("style");
	    };

	    function switchToLogin() {
	      $window.location.replace(
	      $window.location.protocol +
	      "//" +
	      $window.location.host +
	      "/portalserver/" +
	      lpPortal.name +
	      "/sign-in");

	    }

	    $scope.forgotPassword = function () {
	      $window.location.replace(
	      $window.location.protocol +
	      "//" +
	      $window.location.host +
	      "/portalserver/" +
	      lpPortal.name +
	      "/forgot-password");

	    };

	    $scope.goToContactPage = function () {
	      var url =
	      $window.location.protocol +
	      "//" +
	      $window.location.host +
	      "/portalserver/" +
	      lpPortal.name +
	      "/abc-contact";
	      window.open(url, "_blank");
	    };

	    $scope.goToHelpPage = function () {
	      var url =
	      $window.location.protocol +
	      "//" +
	      $window.location.host +
	      "/portalserver/" +
	      lpPortal.name +
	      "/help";
	      window.open(url, "_blank");
	    };

	    $scope.goToSecurityTipsPage = function () {
	      var url =
	      $window.location.protocol +
	      "//" +
	      $window.location.host +
	      "/portalserver/" +
	      lpPortal.name +
	      "/security-tips";
	      window.open(url, "_blank");
	    };

	    $scope.goToBranchLocatorPage = function () {
	      var url =
	      $window.location.protocol +
	      "//" +
	      $window.location.host +
	      "/portalserver/" +
	      lpPortal.name +
	      "/branch-locator";
	      window.open(url, "_blank");
	    };

	    $scope.goToRegisterPage = function () {
	      var url =
	      $window.location.protocol +
	      "//" +
	      $window.location.host +
	      "/portalserver/" +
	      lpPortal.name +
	      "/register";
	      window.open(url, "_blank");
	    };

	    $scope.goToCookiePolicyPage = function () {
	      var url =
	      $window.location.protocol +
	      "//" +
	      $window.location.host +
	      "/portalserver/" +
	      lpPortal.name +
	      "/cookies-policy";
	      window.open(url, "_blank");
	    };

	    $scope.logout = function () {
	      LoginService.logout($scope.BBXSRF, true);
	    };
	  };
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 11 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict';!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {
	    'use strict';

	    // @ngInject
	    exports.autofill = function () {
	        return {
	            require: '?ngModel',
	            restrict: 'A',
	            link: function link(scope, element, attrs, ngModel) {
	                scope.$on('autofill:update', function () {
	                    ngModel.$setViewValue(element.val());
	                });
	            } };

	    };
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }
/******/ ])
});
;


// WEBPACK FOOTER //
// scripts/main.js